import{j as r}from"./chunk-GEPA7FLG.js";r();import{useRef as u,useEffect as n}from"react";function i(t){let e=u();return n(()=>{e.current=t}),e.current}export{i as a};
//# sourceMappingURL=chunk-M4TVU57V.js.map
